import { fetchWrapper } from "@/helpers";
import { useAuth } from "@/stores";

const ruta = process.env.VUE_APP_ROOT_API;

// Ítem 12 (alertas_stock_resultado.md): alertas de stock negativo que crean las ventas offline al sincronizarse.
// Con fetchWrapper.raw ({ ok, status, data }): la pantalla distingue 403, 404, 409 y 422 por el status, sin depender
// del texto con el que rechaza fetchWrapper.get/post. Un 401 cierra sesión, como el resto del sistema.
function revisarSesion(respuesta) {
  if (respuesta.status === 401) useAuth().userLogout();
  return respuesta;
}

export default class AlertaStockService {
  // GET /alertas-stock-negativo?sucursal_id=&estado= (estado: 'pendiente' | 'resuelta'; sucursal obligatoria)
  async listar({ sucursal_id, estado = "pendiente" }) {
    const query = new URLSearchParams({ sucursal_id, estado }).toString();
    return revisarSesion(await fetchWrapper.raw("GET", `${ruta}/alertas-stock-negativo?${query}`, null, { timeoutMs: 30000 }));
  }

  // POST /alertas-stock-negativo/{id}/resolver → 200 | 403 | 404 | 409
  async resolver(id) {
    return revisarSesion(await fetchWrapper.raw("POST", `${ruta}/alertas-stock-negativo/${Number(id)}/resolver`, null, { timeoutMs: 30000 }));
  }
}
